<mat-chip-list class="chips_wrp without_ordered start_page_chips">
  <!-- <div class="log" (click)="log()">log</div> -->

  <ng-template #elseTemplateOutletNotSet>
    {{ "Not Set" | translate}}
  </ng-template>

  <mat-chip (removed)="removeValue('q')" *ngIf="filter.get('q').value">
    {{filter.get('q').value}}
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip (removed)="removeValue('is_parameter_value')" *ngIf="filter.get('is_parameter_value') && (filter.get('is_parameter_value').value || filter.get('is_parameter_value').value === 0)">
    <ng-container [ngSwitch]="filter.get('is_parameter_value').value">
        <ng-container *ngSwitchCase="0">
            {{ "Without tags" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="1">
            {{ "With tags" | translate }}
        </ng-container>
    </ng-container>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip #cardTypeChip (removed)="removeValue('task_status_id')" *ngIf="filter.get('task_status_id').value">
    <div class="cp" (click)="openFilter($event, cardTypeChip, 'task_status_id')">
      {{ getTaskStatusById(filter.get('task_status_id').value)?.name }}
    </div>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <ng-container *ngIf="filter.get('task_parameter_value_id').value.length">
    <div class="d-f-c" #tagCardChip>
      <span (click)="openFilter($event, tagCardChip, 'task_parameter_value_id')" class="cp chip_out_label">{{ "Tag for task" | translate }}</span>
      <ng-container *ngFor="let forTaskParamValueId of filter.get('task_parameter_value_id').value" >
        <mat-chip #cardTagChipSingle (removed)="removeValueFromMultiple('task_parameter_value_id', forTaskParamValueId)">
          <div class="cp" (click)="openFilter($event, cardTagChipSingle, 'task_parameter_value_id', forTaskParamValueId)">
            {{ getValueById(forTaskParamValueId)?.value }}
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="filter.get('task_operation_parameter_value_id').value.length">
    <div class="d-f-c" #tagJobChip>
      <span (click)="openFilter($event, tagJobChip, 'task_operation_parameter_value_id')" class="cp chip_out_label">{{ "Tag for job" | translate }}</span>
      <ng-container *ngFor="let forTaskParamValueId of filter.get('task_operation_parameter_value_id').value" >
        <mat-chip #jobTagChipSingle (removed)="removeValueFromMultiple('task_operation_parameter_value_id', forTaskParamValueId)">
          <div class="cp" (click)="openFilter($event, jobTagChipSingle, 'task_operation_parameter_value_id', forTaskParamValueId)">
            {{ getValueById(forTaskParamValueId)?.value }}
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="filter.get('discussion_parameter_value_id').value.length">
    <div class="d-f-c" #tagChatChip>
      <span (click)="openFilter($event, tagChatChip, 'discussion_parameter_value_id')" class="cp chip_out_label">{{ "Tag for chat" | translate }}</span>
      <ng-container *ngFor="let forTaskParamValueId of filter.get('discussion_parameter_value_id').value" >
        <mat-chip #chatTagChipSingle (removed)="removeValueFromMultiple('discussion_parameter_value_id', forTaskParamValueId)">
          <div class="cp" (click)="openFilter($event, chatTagChipSingle, 'discussion_parameter_value_id', forTaskParamValueId)">
            {{ getValueById(forTaskParamValueId)?.value }}
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="filter.get('file_parameter_value_id').value.length">
    <div class="d-f-c" #tagFileChip>
      <span (click)="openFilter($event, tagFileChip, 'file_parameter_value_id')" class="cp chip_out_label">{{ "Tag for file" | translate }}</span>
      <ng-container *ngFor="let forTaskParamValueId of filter.get('file_parameter_value_id').value" >
        <mat-chip #fileTagChipSingle (removed)="removeValueFromMultiple('file_parameter_value_id', forTaskParamValueId)">
          <div class="cp" (click)="openFilter($event, fileTagChipSingle, 'file_parameter_value_id', forTaskParamValueId)">
            {{ getValueById(forTaskParamValueId)?.value }}
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="filter.get('parameter_value_id').value.length">
    <div class="d-f-c" #tagEveryChip>
      <span (click)="openFilter($event, tagEveryChip, 'parameter_value_id')" class="cp chip_out_label">{{ "Tag for everywhere" | translate }}</span>
      <ng-container *ngFor="let forTaskParamValueId of filter.get('parameter_value_id').value" >
        <mat-chip #everyTagChipSingle (removed)="removeValueFromMultiple('parameter_value_id', forTaskParamValueId)">
          <div class="cp" (click)="openFilter($event, everyTagChipSingle, 'parameter_value_id', forTaskParamValueId)">
            {{ getValueById(forTaskParamValueId)?.value }}
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="filter.get('group_id').value.length">
    <div class="d-f-c" #groupChip>
      <span (click)="openFilter($event, groupChip, 'group_id')" class="cp chip_out_label">{{ "Group" | translate }}</span>
      <ng-container *ngFor="let id of filter.get('group_id').value" >
        <mat-chip #groupChipSingle (removed)="removeValueFromMultiple('group_id', id)">
          <div class="cp" (click)="openFilter($event, groupChipSingle, 'group_id', id)">
            <ng-container *ngIf="id === 0; else elseTemplateNoGroup">
              {{ "Goup not set" | translate }}
            </ng-container>
            <ng-template #elseTemplateNoGroup>
              {{getGroup(id) ? getGroup(id)?.name : getPartnerGroup(id)?.name}}
            </ng-template>
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>
  
  <ng-container *ngIf="filter.get('channel_id').value.length">
    <div class="d-f-c" #channelChip>
      <span (click)="openFilter($event, channelChip, 'channel_id')" class="cp chip_out_label">{{ "Card Outlets" | translate }}</span>
      <ng-container *ngFor="let id of filter.get('channel_id').value" >
        <mat-chip [ngClass]="{'user_chip': id != 0}" #channelChipSingle (removed)="removeValueFromMultiple('channel_id', id)">
          <div class="cp" (click)="openFilter($event, channelChipSingle, 'channel_id', id)">
            <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
              <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
            </ng-container>
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="filter.get('no_channel_id').value.length">
    <div class="d-f-c" #noChannelChip>
      <span (click)="openFilter($event, noChannelChip, 'no_channel_id')" class="cp chip_out_label">{{ "Not Presented" | translate }}</span>
      <ng-container *ngFor="let id of filter.get('no_channel_id').value" >
        <mat-chip [ngClass]="{'user_chip': id != 0}" #noChannelChipSingle (removed)="removeValueFromMultiple('no_channel_id', id)">
          <div class="cp" (click)="openFilter($event, noChannelChipSingle, 'no_channel_id', id)">
            <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
              <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
            </ng-container>
          </div>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
      </ng-container>
    </div>
  </ng-container>

  <mat-chip #contentStatusChip (removed)="removeValue('content_status_id')" *ngIf="filter.get('content_status_id').value">
    <div class="cp" (click)="openFilter($event, contentStatusChip, 'content_status_id')">
      {{ getProfileStatus(filter.get('content_status_id').value)?.name+'_profile' | translate }}
    </div>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip #isContentUrlChip (removed)="removeValue('is_content_url')" *ngIf="filter.get('is_content_url').value || filter?.get('is_content_url').value == '0'">
    <div class="cp" (click)="openFilter($event, isContentUrlChip, 'is_content_url')">
      {{ contentUrl[filter.get('is_content_url').value].name }}
    </div>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <ng-container *ngIf="filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
    <span class="chip_out_label">{{ "Card Added" | translate }}</span>

    <div class="chip_splash"></div>
    
    <ng-container *ngIf="filter.get('task_created_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #taskCreatedAtFromChip (removed)="removeValue('task_created_at_from')">
        <div class="cp" (click)="openFilter($event, taskCreatedAtFromChip, 'task_created_at_from')">
          {{ filter?.get('task_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>

    <ng-container *ngIf="filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>
      <mat-chip #taskCreatedAtToChip (removed)="removeValue('task_created_at_to')">
        <div class="cp" (click)="openFilter($event, taskCreatedAtToChip, 'task_created_at_to')">
          <ng-container *ngIf="filter.get('task_created_at_to').value == 0; else elseTemplateCompletedFilter">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateCompletedFilter>
            {{ filter?.get('task_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
    <span class="chip_out_label">{{ "Job added" | translate }}</span>

    <div class="chip_splash"></div>


    <ng-container *ngIf="filter.get('task_operation_created_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #jobCreatedAtFromChip (removed)="removeValue('task_operation_created_at_from')">
        <div class="cp" (click)="openFilter($event, jobCreatedAtFromChip, 'task_operation_created_at_from')">
          {{ filter?.get('task_operation_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>

    <ng-container *ngIf="filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>
      <mat-chip #jobCreatedAtToChip (removed)="removeValue('task_operation_created_at_to')">
        <div class="cp" (click)="openFilter($event, jobCreatedAtToChip, 'task_operation_created_at_to')">
          <ng-container *ngIf="filter.get('task_operation_created_at_to').value == 0; else elseTemplateCompletedFilter">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateCompletedFilter>
            {{ filter?.get('task_operation_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
    <span class="chip_out_label">{{ "Job completed" | translate }}</span>

    <div class="chip_splash"></div>

    <ng-container *ngIf="filter.get('task_operation_completed_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #jobCompletedAtFromChip (removed)="removeValue('task_operation_completed_at_from')">
        <div class="cp" (click)="openFilter($event, jobCompletedAtFromChip, 'task_operation_completed_at_from')">
          {{ filter?.get('task_operation_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>


    <ng-container *ngIf="filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>

      <mat-chip #jobCompletedAtToChip (removed)="removeValue('task_operation_completed_at_to')">
        <div class="cp" (click)="openFilter($event, jobCompletedAtToChip, 'task_operation_completed_at_to')">
          <ng-container *ngIf="filter.get('task_operation_completed_at_to').value == 0; else elseTemplateCompletedFilter">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateCompletedFilter>
            {{ filter?.get('task_operation_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
    <span class="chip_out_label">{{ "Chat added" | translate }}</span>

    <div class="chip_splash"></div>
    

    <ng-container *ngIf="filter.get('discussion_created_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #discCreatedAtFromChip (removed)="removeValue('discussion_created_at_from')">
        <div class="cp" (click)="openFilter($event, discCreatedAtFromChip, 'discussion_created_at_from')">
          {{ filter?.get('discussion_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>


    <ng-container *ngIf="filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>

      <mat-chip #discCreatedAtToChip (removed)="removeValue('discussion_created_at_to')">
        <div class="cp" (click)="openFilter($event, discCreatedAtToChip, 'discussion_created_at_to')">
          <ng-container *ngIf="filter.get('discussion_created_at_to').value == 0; else elseTemplateDiscCrToFilter">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateDiscCrToFilter>
            {{ filter?.get('discussion_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
    <span class="chip_out_label">{{ "File added" | translate }}</span>

    <div class="chip_splash"></div>

    <ng-container *ngIf="filter.get('file_created_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #fileAddedAtFromChip (removed)="removeValue('file_created_at_from')">
        <div class="cp" (click)="openFilter($event, fileAddedAtFromChip, 'file_created_at_from')">
          {{ filter?.get('file_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>


    <ng-container *ngIf="filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>

      <mat-chip #fileAddedAtToChip (removed)="removeValue('file_created_at_to')">
        <div class="cp" (click)="openFilter($event, fileAddedAtToChip, 'file_created_at_to')">
          <ng-container *ngIf="filter.get('file_created_at_to').value == 0; else elseTemplateFileAdd">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateFileAdd>
            {{ filter?.get('file_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
    <span class="chip_out_label">{{ "File updated" | translate }}</span>

    <div class="chip_splash"></div>
    
    <ng-container *ngIf="filter.get('file_updated_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #fileUpdatedAtFromChip (removed)="removeValue('file_updated_at_from')">
        <div class="cp" (click)="openFilter($event, fileUpdatedAtFromChip, 'file_updated_at_from')">
          {{ filter?.get('file_updated_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>


    <ng-container *ngIf="filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>

      <mat-chip #fileUpdatedAtToChip (removed)="removeValue('file_updated_at_to')">
        <div class="cp" (click)="openFilter($event, fileUpdatedAtToChip, 'file_updated_at_to')">
          <ng-container *ngIf="filter.get('file_updated_at_to').value == 0; else elseTemplateFileUpd">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateFileUpd>
            {{ filter?.get('file_updated_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
    <span class="chip_out_label">{{ "File created" | translate }}</span>

    <div class="chip_splash"></div>

    <ng-container *ngIf="filter.get('file_meta_creation_time_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #fileCreatedAtFromChip (removed)="removeValue('file_meta_creation_time_from')">
        <div class="cp" (click)="openFilter($event, fileCreatedAtFromChip, 'file_meta_creation_time_from')">
          {{ filter?.get('file_meta_creation_time_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>


    <ng-container *ngIf="filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>

      <mat-chip #fileCreatedAtToChip (removed)="removeValue('file_meta_creation_time_to')">
        <div class="cp" (click)="openFilter($event, fileCreatedAtToChip, 'file_meta_creation_time_to')">
          <ng-container *ngIf="filter.get('file_meta_creation_time_to').value == 0; else elseTemplateFileCr">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplateFileCr>
            {{ filter?.get('file_meta_creation_time_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
    <span class="chip_out_label">{{ "Post published" | translate }}</span>

    <div class="chip_splash"></div>
    
    <ng-container *ngIf="filter.get('task_channel_published_at_from').value">
      <span class="small_chip_out_label">{{ "from" | translate}}</span>
      <mat-chip #postPublishedAtFromChip (removed)="removeValue('task_channel_published_at_from')">
        <div class="cp" (click)="openFilter($event, postPublishedAtFromChip, 'task_channel_published_at_from')">
          {{ filter?.get('task_channel_published_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>


    <ng-container *ngIf="filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
      <span class="small_chip_out_label">{{ "to" | translate}}</span>

      <mat-chip #postPublishedAtToChip (removed)="removeValue('task_channel_published_at_to')">
        <div class="cp" (click)="openFilter($event, postPublishedAtToChip, 'task_channel_published_at_to')">
          <ng-container *ngIf="filter.get('task_channel_published_at_to').value == 0; else elseTemplatePublPost">
            {{ "Without date" | translate }}
          </ng-container>
          <ng-template #elseTemplatePublPost>
            {{ filter?.get('task_channel_published_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </div>
      </mat-chip>
    </ng-container>
  </ng-container>

  <mat-chip class="red_chip" #singleNAJobTypeChip (removed)="removeValue('no_operation_id')" *ngIf="filter.get('no_operation_id').value">
    <div class="cp" (click)="openFilter($event, singleNAJobTypeChip, 'no_operation_id')">
      {{ "Not assigned" | translate }}: {{ getColumnName(filter.get('no_operation_id').value) }}
    </div>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip class="user_chip" (removed)="removeValue('origin_company_id')" *ngIf="filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)">
    {{ "Partner Client" | translate }}:
    <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('origin_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip class="user_chip" #clientChip (removed)="removeValue('client_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('client_employee_id').value)?.user_id}" *ngIf="section != 'Chats' && filter.get('client_employee_id').value">
    <div class="cp d-f-c" (click)="openFilter($event, clientChip, 'client_employee_id')">
      {{ "Client" | translate }}:
      <app-user [class]="'user_div ml-1'" [employee]="getEmployee(filter.get('client_employee_id').value)"></app-user>
    </div>
    
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip class="user_chip" #contentTypeChip (removed)="removeValue('content_type_id')"  *ngIf="filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0'">
    <div class="cp d-f-c" (click)="openFilter($event, contentTypeChip, 'content_type_id')">
      <ng-container *ngIf="filter.get('content_type_id').value.toString() == '0'; else elseTemplateZeroContent">
          {{ "Content Type" | translate }}: {{ "Not set" | translate }}
      </ng-container>
      <ng-template #elseTemplateZeroContent>
          {{ "Content Type" | translate }}: {{ getContentById(filter.get('content_type_id').value)?.name }}
      </ng-template>
    </div>
 
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <mat-chip class="user_chip" #platformChip (removed)="removeValue('channel_platform_id')" *ngIf="!!filter.get('channel_platform_id').value || filter.get('channel_platform_id').value.toString() == '0'">
    <div class="platform_wrp cp" (click)="openFilter($event, platformChip, 'channel_platform_id')">
      <div>
        <app-platform [platform_id]="filter.get('channel_platform_id').value"></app-platform>
      </div>
      {{ getPlatformById(filter.get('channel_platform_id').value)?.name }}
    </div>
    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
  </mat-chip>

  <ng-container *ngIf="section == 'Posts'">
    <mat-chip class="user_chip" #userChip (removed)="removeValue('operation_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" *ngIf="filter.get('operation_employee_id').value">
      <div class="cp" (click)="openFilter($event, userChip, 'operation_employee_id')">
        <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
          {{ "Without executor" | translate }} 
        </ng-container>
        <ng-template #elseTemplateWithoutExec>
          <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
        </ng-template>
      </div>
      
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip class="user_chip" #partnerChip (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value">
      <div class="cp d-f-c" (click)="openFilter($event, partnerChip, 'operation_partner_company_id')">
        {{ "Partner" | translate }}:
        <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('views_update_interval')" *ngIf="filter.get('views_update_interval').value">
      {{ getViewsUpdateIntervalListByValue(filter.get('views_update_interval').value)?.name | translate }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <mat-chip (removed)="removeValue('scheduled_published_time_by')" *ngIf="filter.get('scheduled_published_time_by').value">
      {{ "Posting method" | translate }}: {{filter.get('scheduled_published_time_by').value + '_sch_type' | translate}}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('external_status')" *ngIf="filter.get('external_status').value">
      {{ "Privacy Status" | translate }}: <span class="fl">{{ filter.get('external_status').value | translate }}</span>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('is_content_views_count_update')" *ngIf="filter.get('is_content_views_count_update').value">
      <ng-container [ngSwitch]="filter.get('is_content_views_count_update').value">
          <ng-container *ngSwitchCase="0">
              {{ "Without auto-update" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="1">
              {{ "With auto-update" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="2">
              {{ "Error in update" | translate }}
          </ng-container>
      </ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('is_live_stream_archive')" *ngIf="(filter.get('is_live_stream_archive') && (filter.get('is_live_stream_archive').value || filter.get('is_live_stream_archive').value === 0))">
      {{ "Archived" | translate }}:
      <ng-container [ngSwitch]="filter.get('is_live_stream_archive').value">
          <ng-container *ngSwitchCase="0">
              {{ "No" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="1">
              {{ "Yes" | translate }}
          </ng-container>
      </ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <mat-chip (removed)="removeValue('is_bravourl_content_views_count_update')" *ngIf="filter.get('is_bravourl_content_views_count_update').value">
      <ng-container [ngSwitch]="filter.get('is_bravourl_content_views_count_update').value">
          <ng-container *ngSwitchCase="0">
              {{ "Without auto-update" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="1">
              {{ "With auto-update" | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="2">
              {{ "Error in update" | translate }}
          </ng-container>
      </ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <ng-container *ngIf="filter.get('created_employee_id').value && filter.get('created_employee_id').value.length > 0 && !filter.get('created_employee_id').value.includes(0)">
      <mat-chip class="user_chip" (removed)="removeValue('created_employee_id')" >
          <span class="mr-1 ml-1" style="font-weight: 500;">{{ "Created profile" | translate }}</span>
          <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('created_employee_id').value)"></app-user>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <ng-container *ngIf="filter.get('updated_employee_id').value && filter.get('updated_employee_id').value.length > 0 && !filter.get('updated_employee_id').value.includes(0)">
        <mat-chip class="user_chip" (removed)="removeValue('updated_employee_id')" >
            <span class="mr-1 ml-1" style="font-weight: 500;">{{ "Updated profile" | translate }}</span>
            <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('updated_employee_id').value)"></app-user>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
    </ng-container>
    <ng-container *ngIf="filter.get('created_url_employee_id').value && filter.get('created_url_employee_id').value.length > 0 && !filter.get('created_url_employee_id').value.includes(0)">
        <mat-chip class="user_chip" (removed)="removeValue('created_url_employee_id')" >
            <span class="mr-1 ml-1" style="font-weight: 500;">{{ "Created url" | translate }}</span>
            <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('created_url_employee_id').value)"></app-user>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
    </ng-container>
    <ng-container *ngIf="filter.get('updated_url_employee_id').value && filter.get('updated_url_employee_id').value.length > 0 && !filter.get('updated_url_employee_id').value.includes(0)">
        <mat-chip class="user_chip" (removed)="removeValue('updated_url_employee_id')" >
            <span class="mr-1 ml-1" style="font-weight: 500;">{{ "Updated url" | translate }}</span>
            <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('updated_url_employee_id').value)"></app-user>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip>
    </ng-container>
    <ng-container *ngIf="filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0'">
      <span class="chip_out_label">{{ "Post created" | translate }}</span>

      <div class="chip_splash"></div>

      <ng-container *ngIf="filter.get('created_at_from').value">
        <span class="small_chip_out_label">{{ "from" | translate}}</span>
        <mat-chip #postCreatedAtFromChip (removed)="removeValue('created_at_from')">
          <div class="cp" (click)="openFilter($event, postCreatedAtFromChip, 'created_at_from')">
            {{ filter?.get('created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
  
  
      <ng-container *ngIf="filter.get('created_at_to').value || filter?.get('created_at_to').value == '0'">
        <span class="small_chip_out_label">{{ "to" | translate}}</span>
  
        <mat-chip #postCreatedAtToChip (removed)="removeValue('created_at_to')">
          <div class="cp" (click)="openFilter($event, postCreatedAtToChip, 'created_at_to')">
            <ng-container *ngIf="filter.get('created_at_to').value == 0; else elseTemplatePostCr">
              {{ "Without date" | translate }}
            </ng-container>
            <ng-template #elseTemplatePostCr>
              {{ filter?.get('created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            </ng-template>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="filter.get('analytics_views_count_from').value || filter.get('analytics_views_count_to').value || filter?.get('analytics_views_count_to').value == '0'">
      <span class="chip_out_label">{{ "Post analytics" | translate }}</span>

      <div class="chip_splash"></div>
      

      <ng-container *ngIf="filter.get('analytics_views_count_from').value">
        <span class="small_chip_out_label">{{ "from" | translate}}</span>
        <mat-chip #postAnalyticsAtFromChip (removed)="removeValue('analytics_views_count_from')">
          <div class="cp" (click)="openFilter($event, postAnalyticsAtFromChip, 'analytics_views_count_from')">
            {{ filter?.get('analytics_views_count_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
  
  
      <ng-container *ngIf="filter.get('analytics_views_count_to').value || filter?.get('analytics_views_count_to').value == '0'">
        <span class="small_chip_out_label">{{ "to" | translate}}</span>
  
        <mat-chip #postAnalyticsAtToChip (removed)="removeValue('analytics_views_count_to')">
          <div class="cp" (click)="openFilter($event, postAnalyticsAtToChip, 'analytics_views_count_to')">
            <ng-container *ngIf="filter.get('analytics_views_count_to').value == 0; else elseTemplatePostAnalytics">
              {{ "Without date" | translate }}
            </ng-container>
            <ng-template #elseTemplatePostAnalytics>
              {{ filter?.get('analytics_views_count_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            </ng-template>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="filter.get('content_published_at_from').value || filter.get('content_published_at_to').value || filter?.get('content_published_at_to').value == '0'">
      <span class="chip_out_label">{{ "Published" | translate }}</span>

      <div class="chip_splash"></div>
      
      <ng-container *ngIf="filter.get('content_published_at_from').value">
        <span class="small_chip_out_label">{{ "from" | translate}}</span>
        <mat-chip #contentPublAtFromChip (removed)="removeValue('content_published_at_from')">
          <div class="cp" (click)="openFilter($event, contentPublAtFromChip, 'content_published_at_from')">
            {{ filter?.get('content_published_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
  
  
      <ng-container *ngIf="filter.get('content_published_at_to').value || filter?.get('content_published_at_to').value == '0'">
        <span class="small_chip_out_label">{{ "to" | translate}}</span>
  
        <mat-chip #contentPublAtToChip (removed)="removeValue('content_published_at_to')">
          <div class="cp" (click)="openFilter($event, contentPublAtToChip, 'content_published_at_to')">
            <ng-container *ngIf="filter.get('content_published_at_to').value == 0; else elseTemplateConPubl">
              {{ "Without date" | translate }}
            </ng-container>
            <ng-template #elseTemplateConPubl>
              {{ filter?.get('content_published_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            </ng-template>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </ng-container>

    <mat-icon *ngIf="filter.get('q').value || filter.get('operation_employee_id').value || filter.get('external_status').value || filter.get('scheduled_published_time_by').value || (filter.get('content_published_at_from').value || filter.get('content_published_at_to').value || filter?.get('content_published_at_to').value == '0') || filter.get('no_channel_id').value.length || filter.get('no_operation_id').value || (filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)) || filter.get('operation_partner_company_id').value || filter.get('views_update_interval').value || filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0' || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || filter.get('task_status_id').value || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || filter.get('content_type_id').value.toString() == '0' || filter.get('group_id').value.length || filter.get('channel_platform_id').value.toString() == '0' || filter.get('task_custom_id').value || (filter.get('created_employee_id').value && filter.get('created_employee_id').value.length > 0 && !filter.get('created_employee_id').value.includes(0)) || (filter.get('updated_employee_id').value && filter.get('updated_employee_id').value.length > 0 && !filter.get('updated_employee_id').value.includes(0)) || (filter.get('created_url_employee_id').value && filter.get('created_url_employee_id').value.length > 0 && !filter.get('created_url_employee_id').value.includes(0)) || (filter.get('updated_url_employee_id').value && filter.get('updated_url_employee_id').value.length > 0 && !filter.get('updated_url_employee_id').value.includes(0)) || filter.get('is_content_views_count_update').value || (filter.get('is_live_stream_archive') && (filter.get('is_live_stream_archive').value || filter.get('is_live_stream_archive').value === 0)) || filter.get('is_bravourl_content_views_count_update').value || filter.get('content_type_id').value || filter.get('channel_platform_id').value || filter.get('channel_id').value.length || filter?.get('content_status_id').value" class="remove_all_chips_btn" (click)="removeValue('all')">cancel</mat-icon>
  </ng-container>

  <ng-container *ngIf="section == 'Cards'">

    <mat-chip (removed)="removeValue('q_task_name')" *ngIf="filter?.get('q_task_name')?.value">
      {{ "Card Title" | translate }}: {{ filter?.get('q_task_name')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
      <mat-chip (removed)="removeValue('q_task_comment')" *ngIf="filter?.get('q_task_comment')?.value">
      {{ "Card description" | translate }}: {{ filter?.get('q_task_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('q_task_private_comment')" *ngIf="filter?.get('q_task_private_comment')?.value">
      {{ "Card private comment" | translate }}: {{ filter?.get('q_task_private_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('p')" *ngIf="filter?.get('p')?.value">
      {{ "Search Everywhere" | translate }} v2: {{ filter?.get('p')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('p_task_name')" *ngIf="filter?.get('p_task_name')?.value">
      {{ "Card Title" | translate }} v2: {{ filter?.get('p_task_name')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
      <mat-chip (removed)="removeValue('p_task_comment')" *ngIf="filter?.get('p_task_comment')?.value">
      {{ "Card description" | translate }} v2: {{ filter?.get('p_task_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('p_task_private_comment')" *ngIf="filter?.get('p_task_private_comment')?.value">
      {{ "Card private comment" | translate }} v2: {{ filter?.get('p_task_private_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('w')" *ngIf="filter?.get('w')?.value">
      {{ "Search Everywhere" | translate }} v3: {{ filter?.get('w')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('w_task_name')" *ngIf="filter?.get('w_task_name')?.value">
      {{ "Card Title" | translate }} v3: {{ filter?.get('w_task_name')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
      <mat-chip (removed)="removeValue('w_task_comment')" *ngIf="filter?.get('w_task_comment')?.value">
      {{ "Card description" | translate }} v3: {{ filter?.get('w_task_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('w_task_private_comment')" *ngIf="filter?.get('w_task_private_comment')?.value">
      {{ "Card private comment" | translate }} v3: {{ filter?.get('w_task_private_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <!-- <mat-chip class="user_chip" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" (removed)="removeValue('operation_employee_id')" *ngIf="filter.get('operation_employee_id').value && !!filter.get('operation_employee_id').value.length">
      <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
        {{ "Without executor" | translate }} 
      </ng-container>
      <ng-template #elseTemplateWithoutExec>
        <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
      </ng-template>
      
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip> -->

    <!-- <mat-chip class="user_chip" (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value && !!filter.get('operation_partner_company_id').value.length">
      {{ "Partner" | translate }}:
      <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip> -->

    <mat-chip class="user_chip" #userChip (removed)="removeValue('operation_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" *ngIf="filter.get('operation_employee_id').value && !!filter.get('operation_employee_id').value.length">
      <div class="cp" (click)="openFilter($event, userChip, 'operation_employee_id')">
        <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
          {{ "Without executor" | translate }} 
        </ng-container>
        <ng-template #elseTemplateWithoutExec>
          <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
        </ng-template>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip class="user_chip" #partnerChip (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value && !!filter.get('operation_partner_company_id').value.length">
      <div class="cp d-f-c" (click)="openFilter($event, partnerChip, 'operation_partner_company_id')">
        {{ "Partner" | translate }}:
        <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <mat-chip (removed)="removeValue('operation_status_id')" *ngIf="filter.get('operation_status_id').value.length && !filter.get('operation_status_id').value.includes(0)">
      {{ getFilterOperationStatusName(filter.get('operation_status_id').value) }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip #priorityChip (removed)="removeValue('priority')" *ngIf="filter.get('priority').value">
      <div class="cp" (click)="openFilter($event, priorityChip, 'priority')">
        {{getPriority(filter.get('priority').value)?.name | translate}}
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
  

    <mat-chip #taskContentStatusChip (removed)="removeValue('task_content_status_id')" *ngIf="filter.get('task_content_status_id').value || filter.get('task_content_status_id').value.toString() == '0'">
      <div class="cp" (click)="openFilter($event, taskContentStatusChip, 'task_content_status_id')">
        {{ "Card posts in status" | translate }}: 
        <ng-container *ngIf="filter.get('task_content_status_id').value.toString() == '0'; else elseTemplateZeroStatus">
          {{"Different" | translate}}
        </ng-container>
        <ng-template #elseTemplateZeroStatus>
          {{ getProfileStatus(filter.get('task_content_status_id').value)?.name }}
        </ng-template>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('id')" *ngIf="filter?.get('id')?.value">
      {{ "Card system ID" | translate }}: {{ filter?.get('id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('q_task_channel_content_filename')" *ngIf="filter?.get('q_task_channel_content_filename')?.value">
      {{ "Post filename" | translate }}: {{ filter?.get('q_task_channel_content_filename')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('internal_id')" *ngIf="filter?.get('internal_id')?.value">
      {{ "Card Internal Id" | translate }}: {{ filter?.get('internal_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('task_custom_id')" *ngIf="filter?.get('task_custom_id')?.value">
      {{ "Card custom ID" | translate }}: {{ filter?.get('task_custom_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('task_company_id')" *ngIf="filter?.get('task_company_id')?.value">
      {{ "Card workspace ID" | translate }}: {{ filter?.get('task_company_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('q_task_operation_comment')" *ngIf="filter?.get('q_task_operation_comment')?.value">
      {{ "Job title" | translate }}: {{ filter?.get('q_task_operation_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('q_task_operation_employee_comment')" *ngIf="filter?.get('q_task_operation_employee_comment')?.value">
      {{ "Job executor commment" | translate }}: {{ filter?.get('q_task_operation_employee_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('q_task_operation_private_comment')" *ngIf="filter?.get('q_task_operation_private_comment')?.value">
      {{ "Job private commment" | translate }}: {{ filter?.get('q_task_operation_private_comment')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('task_operation_id')" *ngIf="filter?.get('task_operation_id')?.value">
      {{ "Job System ID" | translate }}: {{ filter?.get('task_operation_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('discussion_id')" *ngIf="filter?.get('discussion_id')?.value">
      {{ "Chat System ID" | translate }}: {{ filter?.get('discussion_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-icon *ngIf="filter.get('q').value || (filter.get('is_parameter_value') && (filter.get('is_parameter_value').value || filter.get('is_parameter_value').value === 0)) || filter?.get('internal_id')?.value || (filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)) || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || (filter.get('task_content_status_id').value || filter.get('task_content_status_id').value.toString() == '0') || filter?.get('task_channel_published_at_to').value == '0' || filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0' || (!!filter.get('channel_platform_id').value || filter.get('channel_platform_id').value.toString() == '0') || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || filter.get('no_operation_id').value || filter.get('channel_id').value.length || filter.get('no_channel_id').value.length || filter.get('priority').value || filter?.get('task_status_id').value || filter.get('group_id').value.length || (filter?.get('operation_employee_id').value && !!filter?.get('operation_employee_id').value.length) || (filter?.get('operation_partner_company_id').value && !!filter?.get('operation_partner_company_id').value.length) || filter?.get('task_operation_operation_id').value || (filter.get('operation_status_id').value.length && !filter.get('operation_status_id').value.includes(0)) || filter?.get('content_status_id').value || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || filter?.get('operation_completed_at_from').value || filter?.get('operation_completed_at_to').value || filter?.get('operation_completed_at_to').value == '0' || filter?.get('id')?.value || filter?.get('w')?.value || filter?.get('w_task_name')?.value || filter?.get('w_task_comment')?.value || filter?.get('w_task_private_comment')?.value || filter?.get('p')?.value || filter?.get('p_task_name')?.value || filter?.get('p_task_comment')?.value || filter?.get('p_task_private_comment')?.value || filter?.get('q_task_name')?.value || filter?.get('q_task_comment')?.value || filter?.get('q_task_private_comment')?.value || filter?.get('q_task_channel_content_filename')?.value || filter?.get('task_custom_id')?.value || filter?.get('task_company_id')?.value || filter?.get('q_task_operation_comment')?.value || filter?.get('q_task_operation_employee_comment')?.value || filter?.get('q_task_operation_private_comment')?.value || filter?.get('task_operation_id')?.value || filter?.get('discussion_id')?.value" class="remove_all_chips_btn" (click)="removeValue('all')">cancel</mat-icon>
  </ng-container>

  <ng-container *ngIf="section == 'Chats'; else elseTemplateNoChats">

    <ng-container *ngIf="filter.get('discussion_channel_id').value.length">
      <div class="d-f-c" #discussionChannelChip>
        <span (click)="openFilter($event, discussionChannelChip, 'discussion_channel_id')" class="cp chip_out_label">{{ "Chat Outlets" | translate }}</span>
        <ng-container *ngFor="let id of filter.get('discussion_channel_id').value" >
          <mat-chip [ngClass]="{'user_chip': id != 0}" #discussionChannelChipSingle (removed)="removeValueFromMultiple('discussion_channel_id', id)">
            <div class="cp" (click)="openFilter($event, discussionChannelChipSingle, 'discussion_channel_id', id)">
              <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
              </ng-container>
            </div>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </mat-chip>
        </ng-container>
      </div>
    </ng-container>

    <mat-chip #priorityChip (removed)="removeValue('priority')" *ngIf="filter.get('priority').value.length">
      <div class="cp" (click)="openFilter($event, priorityChip, 'priority')">
        {{getPriority(filter.get('priority').value)?.name | translate}}
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('data_file_id')" *ngIf="filter.get('data_file_id').value !== ''">
      <ng-container *ngIf="filter.get('data_file_id').value === 'isset'">File Chats</ng-container>
      <ng-container *ngIf="filter.get('data_file_id').value === '0'">Just Chats</ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip class="user_chip" #userChip (removed)="removeValue('operation_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" *ngIf="filter.get('operation_employee_id').value && !!filter.get('operation_employee_id').value.length">
      <div class="cp" (click)="openFilter($event, userChip, 'operation_employee_id')">
        <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
          {{ "Without executor" | translate }} 
        </ng-container>
        <ng-template #elseTemplateWithoutExec>
          <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
        </ng-template>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <mat-chip class="user_chip" #partnerChip (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value && !!filter.get('operation_partner_company_id').value.length">
      <div class="cp d-f-c" (click)="openFilter($event, partnerChip, 'operation_partner_company_id')">
        {{ "Partner" | translate }}:
        <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <mat-chip class="user_chip" #clientChip (removed)="removeValue('client_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('client_employee_id').value)?.user_id}" *ngIf="filter.get('client_employee_id').value.length">
      <div class="cp d-f-c" (click)="openFilter($event, clientChip, 'client_employee_id')">
        {{ "Client" | translate }}:
        <app-user [class]="'user_div ml-1'" [employee]="getEmployee(filter.get('client_employee_id').value)"></app-user>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip #chSingleJobTypeChip (removed)="removeValue('task_operation_operation_id')" *ngIf="filter.get('task_operation_operation_id').value && filter.get('task_operation_operation_id').value.length">
      <div class="cp" (click)="openFilter($event, chSingleJobTypeChip, 'task_operation_operation_id')">
        {{ getColumnName(filter.get('task_operation_operation_id').value) }}
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('q_name')" *ngIf="filter?.get('q_name')?.value">
      {{ "Chat title" | translate }}: {{ filter?.get('q_name')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('q_text')" *ngIf="filter?.get('q_text')?.value">
      {{ "Chat messages" | translate }}: {{ filter?.get('q_text')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <ng-container *ngIf="filter.get('posted_at_from').value || filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0'">
      <span class="chip_out_label">{{ "Post added" | translate }}</span>

      <div class="chip_splash"></div>
  
  
      <ng-container *ngIf="filter.get('posted_at_from').value">
        <span class="small_chip_out_label">{{ "from" | translate}}</span>
        <mat-chip #postedAtFromChip (removed)="removeValue('posted_at_from')">
          <div class="cp" (click)="openFilter($event, postedAtFromChip, 'posted_at_from')">
            {{ filter?.get('posted_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
  
      <ng-container *ngIf="filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0'">
        <span class="small_chip_out_label">{{ "to" | translate}}</span>
        <mat-chip #postedAtToChip (removed)="removeValue('posted_at_to')">
          <div class="cp" (click)="openFilter($event, postedAtToChip, 'posted_at_to')">
            <ng-container *ngIf="filter.get('posted_at_to').value == 0; else elseTemplatePosteFilter">
              {{ "Without date" | translate }}
            </ng-container>
            <ng-template #elseTemplatePosteFilter>
              {{ filter?.get('posted_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            </ng-template>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="filter.get('discussion_completed_at_from').value || filter.get('discussion_completed_at_to').value || filter?.get('discussion_completed_at_to').value == '0'">
      <span class="chip_out_label">{{ "Chat Completed" | translate }}</span>

      <div class="chip_splash"></div>
  
  
      <ng-container *ngIf="filter.get('discussion_completed_at_from').value">
        <span class="small_chip_out_label">{{ "from" | translate}}</span>
        <mat-chip #discFromChip (removed)="removeValue('discussion_completed_at_from')">
          <div class="cp" (click)="openFilter($event, discFromChip, 'discussion_completed_at_from')">
            {{ filter?.get('discussion_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
  
      <ng-container *ngIf="filter.get('discussion_completed_at_to').value || filter?.get('discussion_completed_at_to').value == '0'">
        <span class="small_chip_out_label">{{ "to" | translate}}</span>
        <mat-chip #discToChip (removed)="removeValue('discussion_completed_at_to')">
          <div class="cp" (click)="openFilter($event, discToChip, 'discussion_completed_at_to')">
            <ng-container *ngIf="filter.get('discussion_completed_at_to').value == 0; else elseTemplateComplFilter">
              {{ "Without date" | translate }}
            </ng-container>
            <ng-template #elseTemplateComplFilter>
              {{ filter?.get('discussion_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            </ng-template>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </ng-container>

    <mat-chip (removed)="removeValue('task_custom_id')" *ngIf="filter?.get('task_custom_id')?.value">
      {{ "Card custom ID" | translate }}: {{ filter?.get('task_custom_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <ng-container *ngIf="filter.get('discussion_planned_completed_at_from').value || filter.get('discussion_planned_completed_at_to').value || filter?.get('discussion_planned_completed_at_to').value == '0'">
      <span class="chip_out_label">{{ "Deadline" | translate }}</span>

      <div class="chip_splash"></div>

      <ng-container *ngIf="filter.get('discussion_planned_completed_at_from').value">
        <span class="small_chip_out_label">{{ "from" | translate}}</span>
        <mat-chip #discPlFromChip (removed)="removeValue('discussion_planned_completed_at_from')">
          <div class="cp" (click)="openFilter($event, discPlFromChip, 'discussion_planned_completed_at_from')">
            {{ filter?.get('discussion_planned_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
  
      <ng-container *ngIf="filter.get('discussion_planned_completed_at_to').value || filter?.get('discussion_planned_completed_at_to').value == '0'">
        <span class="small_chip_out_label">{{ "to" | translate}}</span>
        <mat-chip #discPlToChip (removed)="removeValue('discussion_planned_completed_at_to')">
          <div class="cp" (click)="openFilter($event, discPlToChip, 'discussion_planned_completed_at_to')">
            <ng-container *ngIf="filter.get('discussion_planned_completed_at_to').value == 0; else elseTemplateComplFilter">
              {{ "Without date" | translate }}
            </ng-container>
            <ng-template #elseTemplateComplFilter>
              {{ filter?.get('discussion_planned_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
            </ng-template>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip>
      </ng-container>
    </ng-container>
      
    <mat-icon class="remove_all_chips_btn" (click)="removeValue('all')" *ngIf="filter.get('q').value || filter.get('data_file_id').value !== '' || (filter.get('discussion_completed_at_from').value || filter.get('discussion_completed_at_to').value || filter?.get('discussion_completed_at_to').value == '0') || (filter.get('no_channel_id') && filter.get('no_channel_id').value && filter.get('no_channel_id').value.length) || filter.get('task_custom_id').value || (filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0') || (filter.get('discussion_channel_id') && filter.get('discussion_channel_id').value && filter.get('discussion_channel_id').value.length) || (filter.get('channel_id') && filter.get('channel_id').value && filter.get('channel_id').value.length) || filter.get('no_operation_id').value || (filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)) || filter.get('discussion_planned_completed_at_from').value || filter.get('discussion_planned_completed_at_to').value || filter?.get('discussion_planned_completed_at_to').value == '0' || filter.get('posted_at_from').value || filter.get('posted_at_to').value || filter?.get('posted_at_to').value == '0' || filter.get('created_at_from').value || filter.get('created_at_to').value || filter?.get('created_at_to').value == '0' || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || (filter.get('task_operation_operation_id').value && filter.get('task_operation_operation_id').value.length) || activatedRoute.snapshot.queryParamMap.get('channel_platform_id') || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || (filter.get('priority').value && filter.get('priority').value.length > 0) || filter.get('group_id').value.length || (filter.get('operation_employee_id').value && filter.get('operation_employee_id').value.length) || (filter.get('client_employee_id').value && filter.get('client_employee_id').value.length) || filter?.get('q_name')?.value || filter?.get('q_text')?.value">cancel</mat-icon>
  </ng-container>
  <ng-template #elseTemplateNoChats>
  </ng-template>

  <ng-container *ngIf="section == 'Jobs'; else elseTemplateNoJobs">
    <mat-chip (removed)="removeValue('status_id')" *ngIf="filter.get('status_id').value.length && !filter.get('status_id').value.includes(0)">
      {{ getFilterOperationStatusName(filter.get('status_id').value) }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <!-- <mat-chip class="user_chip" (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value">
      {{ "Partner" | translate }}:
      <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip> -->

    <mat-chip class="user_chip" #partnerChip (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value">
      <div class="cp d-f-c" (click)="openFilter($event, partnerChip, 'operation_partner_company_id')">
        {{ "Partner" | translate }}:
        <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('task_id')" *ngIf="filter?.get('task_id')?.value">
      {{ "Card system ID" | translate }}: {{ filter?.get('task_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    
    <ng-container *ngIf="filter.get('task_operation_operation_id').value.length">
      <div #jobTypeChip>
        <span (click)="openFilter($event, jobTypeChip, 'task_operation_operation_id')" class="cp chip_out_label">{{ "Job type" | translate }}</span>

        <ng-container *ngFor="let id of filter.get('task_operation_operation_id').value" >
          <mat-chip #jobTypeChipSingle (removed)="removeValueFromMultiple('task_operation_operation_id', id)">
            <div class="cp" (click)="openFilter($event, jobTypeChipSingle, 'task_operation_operation_id', id)">
              {{ getColumnName(id) }}
            </div>
            <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
          </mat-chip>
        </ng-container>

        <!-- <mat-chip *ngFor="let jobID of filter.get('task_operation_operation_id').value" (removed)="removeValueFromMultiple('task_operation_operation_id', jobID)">
          {{ getColumnName(jobID) }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
        </mat-chip> -->
      </div>
    </ng-container>

    <!-- <mat-chip (removed)="removeValue('task_operation_operation_id')" *ngIf="filter.get('task_operation_operation_id').value.length">
      {{ getColumnName(filter.get('task_operation_operation_id').value) }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip> -->

    <ng-container *ngIf="filter.get('operation_employee_id').value || filter.get('operation_employee_id').value === 0">
      <mat-chip class="user_chip" #userChip (removed)="removeValue('operation_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}">
        <div class="cp" (click)="openFilter($event, userChip, 'operation_employee_id')">
          <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
            {{ "Without executor" | translate }} 
          </ng-container>
          <ng-template #elseTemplateWithoutExec>
            <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
          </ng-template>
        </div>
        <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
      </mat-chip>

      <!-- <mat-chip class="user_chip" (removed)="removeValue('operation_employee_id')" >
          <span class="mr-1" style="font-weight: 500;">{{ "Executor" | translate }}</span>
          <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
            {{ "Not Set" | translate }} 
          </ng-container>
          <ng-template #elseTemplateWithoutExec>
            <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
          </ng-template>
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
      </mat-chip> -->
    </ng-container>

    <mat-chip #priorityChip (removed)="removeValue('priority')" *ngIf="filter.get('priority').value">
      <div class="cp" (click)="openFilter($event, priorityChip, 'priority')">
        {{getPriority(filter.get('priority').value)?.name | translate}}
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('task_custom_id')" *ngIf="filter?.get('task_custom_id')?.value">
      {{ "Card custom ID" | translate }}: {{ filter?.get('task_custom_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    
    <ng-container *ngIf="filter.get('updated_at_from').value || filter.get('updated_at_to').value || filter?.get('updated_at_to').value == '0'">
        <span class="chip_out_label">{{ "Job updated" | translate }}</span>

        <div class="chip_splash"></div>
        
        <ng-container *ngIf="filter.get('updated_at_from').value">
          <span class="small_chip_out_label">{{ "from" | translate}}</span>
          <mat-chip #jobUpdatedAtFromChip (removed)="removeValue('updated_at_from')">
            <div class="cp" (click)="openFilter($event, jobUpdatedAtFromChip, 'updated_at_from')">
              {{ filter?.get('updated_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </div>
          </mat-chip>
        </ng-container>
    
    
        <ng-container *ngIf="filter.get('updated_at_to').value || filter?.get('updated_at_to').value == '0'">
          <span class="small_chip_out_label">{{ "to" | translate}}</span>
    
          <mat-chip #jobUpdatedAtToChip (removed)="removeValue('updated_at_to')">
            <div class="cp" (click)="openFilter($event, jobUpdatedAtToChip, 'updated_at_to')">
              <ng-container *ngIf="filter.get('updated_at_to').value == 0; else elseTemplateJobUpd">
                {{ "Without date" | translate }}
              </ng-container>
              <ng-template #elseTemplateJobUpd>
                {{ filter?.get('updated_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
              </ng-template>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </div>
          </mat-chip>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="filter.get('task_operation_planned_completed_at_from').value || filter.get('task_operation_planned_completed_at_to').value || filter?.get('task_operation_planned_completed_at_to').value == '0'">
        <span class="chip_out_label">{{ "Deadline" | translate }}</span>

        <div class="chip_splash"></div>

        <ng-container *ngIf="filter.get('task_operation_planned_completed_at_from').value">
          <span class="small_chip_out_label">{{ "from" | translate}}</span>
          <mat-chip #jobDeadAtFromChip (removed)="removeValue('task_operation_planned_completed_at_from')">
            <div class="cp" (click)="openFilter($event, jobDeadAtFromChip, 'task_operation_planned_completed_at_from')">
              {{ filter?.get('task_operation_planned_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </div>
          </mat-chip>
        </ng-container>
    
    
        <ng-container *ngIf="filter.get('task_operation_planned_completed_at_to').value || filter?.get('task_operation_planned_completed_at_to').value == '0'">
          <span class="small_chip_out_label">{{ "to" | translate}}</span>
    
          <mat-chip #jobDeadAtToChip (removed)="removeValue('task_operation_planned_completed_at_to')">
            <div class="cp" (click)="openFilter($event, jobDeadAtToChip, 'task_operation_planned_completed_at_to')">
              <ng-container *ngIf="filter.get('task_operation_planned_completed_at_to').value == 0; else elseTemplateJobDead">
                {{ "Without date" | translate }}
              </ng-container>
              <ng-template #elseTemplateJobDead>
                {{ filter?.get('task_operation_planned_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
              </ng-template>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </div>
          </mat-chip>
        </ng-container>
    </ng-container>
    
    <mat-icon class="remove_all_chips_btn" (click)="removeValue('all')" *ngIf="filter.get('q').value || filter.get('task_id').value || (filter.get('is_parameter_value') && (filter.get('is_parameter_value').value || filter.get('is_parameter_value').value === 0)) || filter.get('operation_partner_company_id').value || filter.get('task_custom_id').value || filter.get('task_operation_operation_id').value.length || filter.get('task_operation_planned_completed_at_from').value || filter.get('task_operation_planned_completed_at_to').value || filter?.get('task_operation_planned_completed_at_to').value == '0' || filter.get('channel_id').value.length || filter.get('no_channel_id').value.length || filter.get('no_operation_id').value || (filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)) || filter.get('updated_at_from').value || filter.get('updated_at_to').value || filter?.get('updated_at_to').value == '0' || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || filter.get('channel_platform_id').value || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || filter.get('client_employee_id').value || filter.get('operation_employee_id').value || filter.get('operation_employee_id').value === 0 || filter.get('priority').value || (filter.get('status_id').value && filter.get('status_id').value.length > 0) || filter.get('group_id').value.length || filter.get('task_status_id').value">cancel</mat-icon>   
  </ng-container>
  <ng-template #elseTemplateNoJobs>
    
    <!-- <mat-chip (removed)="removeValue('task_operation_operation_id')" *ngIf="filter.get('task_operation_operation_id').value">
      {{ getColumnName(filter.get('task_operation_operation_id').value) }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip> -->

    <mat-chip #singleJobTypeChip (removed)="removeValue('task_operation_operation_id')" *ngIf="filter.get('task_operation_operation_id').value && section != 'Chats'">
      <div class="cp" (click)="openFilter($event, singleJobTypeChip, 'task_operation_operation_id')">
        {{ getColumnName(filter.get('task_operation_operation_id').value) }}
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

  </ng-template>
  

  <ng-container *ngIf="section == 'Files'">
    <mat-chip (removed)="removeValue('filesize_from')" *ngIf="filter.get('filesize_from').value">
      {{ "Filesize from" | translate }}: {{filter.get('filesize_from').value}}GB
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('filesize_to')" *ngIf="filter.get('filesize_to').value">
      {{ "Filesize to" | translate }}: {{filter.get('filesize_to').value}}GB
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('meta_duration_from')" *ngIf="filter.get('meta_duration_from').value">
      {{ "Duration from" | translate }}: {{filter.get('meta_duration_from').value}}m
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('meta_duration_to')" *ngIf="filter.get('meta_duration_to').value">
      {{ "Duration to" | translate }}: {{filter.get('meta_duration_to').value}}m
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <ng-container *ngIf="!!filter.get('operation_reminder_id').value">
      <span class="chip_out_label">{{ "Checklist" | translate }}:</span>
      <mat-chip (removed)="removeValue('operation_reminder_id')" >
          {{ getChecklist(filter.get('operation_reminder_id').value)?.text }}
          <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>

    <mat-chip (removed)="removeValue('file_id')" *ngIf="filter?.get('file_id')?.value">
      {{ "File ID" | translate }}: {{ filter?.get('file_id')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('content_type')" *ngIf="filter?.get('content_type')?.value">
      {{ "Content type" | translate }}: {{ filter?.get('content_type')?.value }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>
    <mat-chip (removed)="removeValue('is_ready_if_approved')" *ngIf="filter.get('is_ready_if_approved').value == '0' || filter.get('is_ready_if_approved').value">
        <ng-container *ngIf="filter.get('is_ready_if_approved').value == '0'; else elseTemplateReadyIf">
            {{ 'Not Ready Version if Approved' | translate }}
        </ng-container>
        <ng-template #elseTemplateReadyIf>
            {{ 'Ready Version if Approved' | translate }}
        </ng-template>
        <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>


    <mat-chip #priorityChip (removed)="removeValue('priority')" *ngIf="filter.get('priority').value">
      <div class="cp" (click)="openFilter($event, priorityChip, 'priority')">
        {{getPriority(filter.get('priority').value)?.name | translate}}
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('part_of_count')" *ngIf="filter.get('part_of_count').value">
      <ng-container [ngSwitch]="filter.get('part_of_count').value">
        <ng-container *ngSwitchCase="'0'">
          {{ "Isn`t part of file" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'isset'">
          {{ "Is part of file" | translate }}
        </ng-container>
      </ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('consist_of_count')" *ngIf="filter.get('consist_of_count').value">
      <ng-container [ngSwitch]="filter.get('consist_of_count').value">
        <ng-container *ngSwitchCase="'0'">
          {{ "Hasn't parts" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'isset'">
          {{ "Has parts" | translate }}
        </ng-container>
      </ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('related_count')" *ngIf="filter.get('related_count').value">
      <ng-container [ngSwitch]="filter.get('related_count').value">
        <ng-container *ngSwitchCase="'0'">
          {{ "Isn`t related" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'isset'">
          {{ "Is related" | translate }}
        </ng-container>
      </ng-container>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('meta_device')" *ngIf="filter.get('meta_device').value">
        {{ filter.get('meta_device').value }}
        <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-chip (removed)="removeValue('task_channel_file_content_status_id')" *ngIf="filter.get('task_channel_file_content_status_id').value">
      {{"Posts file status" | translate}}: {{ (filter.get('task_channel_file_content_status_id').value == 'no' ? "Not used in posts" : getProfileStatus(filter.get('task_channel_file_content_status_id').value)?.name+'_profile') | translate }}
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <!-- <mat-chip class="user_chip" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" (removed)="removeValue('operation_employee_id')" *ngIf="filter.get('operation_employee_id').value && filter?.get('operation_employee_id').value.length > 0">
      <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
      {{ "Without executor" | translate }} 
      </ng-container>
      <ng-template #elseTemplateWithoutExec>
      <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
      </ng-template>
      
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip> -->

    <mat-chip class="user_chip" #userChip (removed)="removeValue('operation_employee_id')" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}"  *ngIf="filter.get('operation_employee_id').value && filter?.get('operation_employee_id').value.length > 0">
      <div class="cp" (click)="openFilter($event, userChip, 'operation_employee_id')">
        <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
          {{ "Without executor" | translate }} 
        </ng-container>
        <ng-template #elseTemplateWithoutExec>
          <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
        </ng-template>
      </div>
      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
    </mat-chip>

    <mat-icon *ngIf="filter.get('q').value || (filter.get('is_parameter_value') && (filter.get('is_parameter_value').value || filter.get('is_parameter_value').value === 0)) || filter.get('meta_duration_from').value || filter.get('meta_duration_to').value || filter.get('filesize_from').value || filter.get('filesize_to').value || filter.get('content_type').value || filter.get('task_custom_id').value || filter?.get('file_id')?.value || filter.get('consist_of_count').value || filter.get('part_of_count').value || filter.get('related_count').value || (filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)) || filter.get('operation_reminder_id').value || (filter.get('is_ready_if_approved').value == '0' || filter.get('is_ready_if_approved').value) || filter.get('meta_device').value || filter.get('priority').value || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || filter.get('task_status_id').value || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || filter.get('content_type_id').value.toString() == '0' || filter.get('no_channel_id').value.length || filter.get('group_id').value.length || filter.get('channel_platform_id').value.toString() == '0' || filter.get('content_type_id').value || filter.get('channel_platform_id').value || filter.get('channel_id').value.length || filter?.get('content_status_id').value || filter?.get('task_channel_file_content_status_id').value" class="remove_all_chips_btn" (click)="removeValue('all')">cancel</mat-icon>
  </ng-container>
</mat-chip-list>

<ng-template #filMenu let-val>
  <section class="fil-menu" [ngClass]="{'calendar_menu': !!val?.isCalendar}">
    <div class="fil_search" *ngIf="val.hasSearch">
      <mat-form-field appearance="legacy" class="full_width_form">
        <mat-label>{{ "Search" | translate }}</mat-label>
        <input [formControl]="searchFil" matInput>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <ng-container [ngSwitch]="val.key">
      <ng-container *ngSwitchCase="'no_channel_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'no_channel_id', val.id)"           
          infinite-scroll
          [scrollWindow]="false"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onDown($event, 'channel_id')">
            <ng-container *ngFor="let fil of profiles$ | async">
                <mat-list-option class="cst_o flex_text" [value]="fil.id" [ngClass]="{'active': val.id == fil.id}">
                  <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('no_channel_id')"           
          infinite-scroll
          [scrollWindow]="false"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onDown($event, 'channel_id')">
            <ng-container *ngFor="let fil of profiles$ | async">
                <mat-list-option class="cst_o flex_text" [value]="fil.id" (click)="setFilValue($event, 'no_channel_id', fil.id)" [ngClass]="{'active': filter.get('no_channel_id').value.includes(fil.id)}">
                  <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('no_channel_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'discussion_channel_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'discussion_channel_id', val.id)"           
          infinite-scroll
          [scrollWindow]="false"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onDown($event, 'discussion_channel_id')">
            <ng-container *ngFor="let fil of profiles$ | async">
                <mat-list-option class="cst_o flex_text" [value]="fil.id" [ngClass]="{'active': val.id == fil.id}">
                  <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('discussion_channel_id')"           
          infinite-scroll
          [scrollWindow]="false"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onDown($event, 'discussion_channel_id')">
            <ng-container *ngFor="let fil of profiles$ | async">
                <mat-list-option class="cst_o flex_text" [value]="fil.id" (click)="setFilValue($event, 'discussion_channel_id', fil.id)" [ngClass]="{'active': filter.get('discussion_channel_id').value.includes(fil.id)}">
                  <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('discussion_channel_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'channel_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'channel_id', val.id)"           
          infinite-scroll
          [scrollWindow]="false"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onDown($event, 'channel_id')">
            <ng-container *ngFor="let fil of profiles$ | async">
                <mat-list-option class="cst_o flex_text" [value]="fil.id" [ngClass]="{'active': val.id == fil.id}">
                  <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('channel_id')"           
          infinite-scroll
          [scrollWindow]="false"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onDown($event, 'channel_id')">
            <ng-container *ngFor="let fil of profiles$ | async">
                <mat-list-option class="cst_o flex_text" [value]="fil.id" (click)="setFilValue($event, 'channel_id', fil.id)" [ngClass]="{'active': filter.get('channel_id').value.includes(fil.id)}">
                  <app-outlet-line [class]="'for_nav'" [channel]="fil" [company_id]="company_id"></app-outlet-line>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('channel_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'parameter_value_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'parameter_value_id', val.id)">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" [ngClass]="{'active': val.id == (filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                  <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                    <span>
                        {{fil?.value}}
                    </span>
                    <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                  </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('parameter_value_id')">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" (click)="setFilValue($event, 'parameter_value_id', filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)" [ngClass]="{'active': filter.get('parameter_value_id').value.includes(filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                    <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                        <span>
                            {{fil?.value}}
                        </span>
                        <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                    </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('parameter_value_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'task_parameter_value_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'task_parameter_value_id', val.id)">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" [ngClass]="{'active': val.id == (filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                  <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                    <span>
                        {{fil?.value}}
                    </span>
                    <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                  </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('task_parameter_value_id')">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" (click)="setFilValue($event, 'task_parameter_value_id', filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)" [ngClass]="{'active': filter.get('task_parameter_value_id').value.includes(filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                    <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                        <span>
                            {{fil?.value}}
                        </span>
                        <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                    </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('task_parameter_value_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'task_operation_parameter_value_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'task_operation_parameter_value_id', val.id)">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" [ngClass]="{'active': val.id == (filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                  <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                    <span>
                        {{fil?.value}}
                    </span>
                    <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                  </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('task_operation_parameter_value_id')">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" (click)="setFilValue($event, 'task_operation_parameter_value_id', filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)" [ngClass]="{'active': filter.get('task_operation_parameter_value_id').value.includes(filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                    <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                        <span>
                            {{fil?.value}}
                        </span>
                        <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                    </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('task_operation_parameter_value_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_parameter_value_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'discussion_parameter_value_id', val.id)">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" [ngClass]="{'active': val.id == (filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                  <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                    <span>
                        {{fil?.value}}
                    </span>
                    <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                  </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('discussion_parameter_value_id')">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" (click)="setFilValue($event, 'discussion_parameter_value_id', filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)" [ngClass]="{'active': filter.get('discussion_parameter_value_id').value.includes(filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                    <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                        <span>
                            {{fil?.value}}
                        </span>
                        <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                    </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('discussion_parameter_value_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'file_parameter_value_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
          <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'file_parameter_value_id', val.id)">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" [ngClass]="{'active': val.id == (filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                  <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                    <span>
                        {{fil?.value}}
                    </span>
                    <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                  </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('file_parameter_value_id')">
            <ng-container *ngFor="let fil of allValues$ | async">
                <mat-list-option class="cst_o flex_text" [value]="filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id" (click)="setFilValue($event, 'file_parameter_value_id', filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)" [ngClass]="{'active': filter.get('file_parameter_value_id').value.includes(filter?.get('is_original')?.value ? (fil.original_id || fil.id) : fil.id)}">
                    <div class="d-f-c" style="justify-content: space-between; width: 90%;">
                        <span>
                            {{fil?.value}}
                        </span>
                        <span class="parameter_name_in_option" style="color: #084c88;">({{ getParameterById(fil?.parameter_id)?.name }})</span> 
                    </div>
                </mat-list-option>
            </ng-container>
          </mat-selection-list>
          <div class="footer_line_fil">
            <button (click)="startSearch('file_parameter_value_id')">{{"Search" | translate}}</button>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'group_id'">
        <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">          
          <ng-container *ngIf="!!activatedRoute.snapshot.queryParamMap.get('groups_partner_id'); else elseTemplateIsOwnGroups">
            <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'group_id', val.id)">
              <mat-list-option [value]="0" [ngClass]="{'active': 0 == val.id}">
                <div class="user_div">
                    <span>
                        {{ "Group not set" | translate }}
                    </span>
                </div>
              </mat-list-option>
              <ng-container *ngFor="let fil of partnerGroups$ | async">
                  <mat-list-option class="cst_o flex_text" [value]="fil.id" [ngClass]="{'active': val.id == fil.id}">
                      <div class="d-f-c">
                          <span>
                              {{fil.name}}
                          </span>
                      </div>
                  </mat-list-option>
              </ng-container>
            </mat-selection-list>
          </ng-container>
          <ng-template #elseTemplateIsOwnGroups>
            <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'group_id', val.id)"            
            infinite-scroll
            [scrollWindow]="false"
            [infiniteScrollUpDistance]="scrollUpDistance"
            [infiniteScrollThrottle]="throttle"
            (scrolled)="onDown($event, 'group_id')">
              <mat-list-option [value]="0" [ngClass]="{'active': 0 == val.id}">
                <div class="user_div">
                    <span>
                        {{ "Group not set" | translate }}
                    </span>
                </div>
              </mat-list-option>
              <ng-container *ngFor="let fil of groups$ | async">
                  <mat-list-option class="cst_o flex_text" [value]="fil.id" [ngClass]="{'active': val.id == fil.id}">
                      <div class="d-f-c">
                          <span>
                              {{fil.name}}
                          </span>
                      </div>
                  </mat-list-option>
              </ng-container>
            </mat-selection-list>
          </ng-template>
        </ng-container>
        <ng-template #elseTemplateIsSingleChange>
          <ng-container *ngIf="!!activatedRoute.snapshot.queryParamMap.get('groups_partner_id'); else elseTemplateIsOwnGroups">
            <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('group_id')">
              <mat-list-option [value]="0" [ngClass]="{'active': filter.get('group_id').value.includes(0)}" (click)="setFilValue($event, 'group_id', 0)">
                <div class="user_div">
                    <span>
                        {{ "Group not set" | translate }}
                    </span>
                </div>
              </mat-list-option>
              <ng-container *ngFor="let fil of partnerGroups$ | async">
                  <mat-list-option class="cst_o flex_text" [value]="fil.id" (click)="setFilValue($event, 'group_id', fil.id)" [ngClass]="{'active': filter.get('group_id').value.includes(fil.id)}">
                      <div class="d-f-c">
                          <span>
                              {{fil.name}}
                          </span>
                      </div>
                  </mat-list-option>
              </ng-container>
            </mat-selection-list>
          </ng-container>
          <ng-template #elseTemplateIsOwnGroups>
            <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true)" [formControl]="filter.get('group_id')"            
            infinite-scroll
            [scrollWindow]="false"
            [infiniteScrollUpDistance]="scrollUpDistance"
            [infiniteScrollThrottle]="throttle"
            (scrolled)="onDown($event, 'group_id')">
              <mat-list-option [value]="0" [ngClass]="{'active': filter.get('group_id').value.includes(0)}" (click)="setFilValue($event, 'group_id', 0)">
                <div class="user_div">
                    <span>
                        {{ "Group not set" | translate }}
                    </span>
                </div>
              </mat-list-option>
              <ng-container *ngFor="let fil of groups$ | async">
                  <mat-list-option class="cst_o flex_text" [value]="fil.id" (click)="setFilValue($event, 'group_id', fil.id)" [ngClass]="{'active': filter.get('group_id').value.includes(fil.id)}">
                      <div class="d-f-c">
                          <span>
                              {{fil.name}}
                          </span>
                      </div>
                  </mat-list-option>
              </ng-container>
            </mat-selection-list>
          </ng-template>
        </ng-template>
        


        <div class="footer_line_fil">
          <button (click)="startSearch('group_id')">{{"Search" | translate}}</button>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'operation_partner_company_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of partners$ | async">
              <mat-list-option class="ch_fil_item" [value]="fil.partner_company_id" [ngClass]="{'active': fil.partner_company_id == filter.get('operation_partner_company_id').value}">
                <app-user [class]="'user_div'" [companyEmployee]="fil?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'operation_employee_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <mat-list-option [value]="0" [ngClass]="{'active': 0 === filter.get('operation_employee_id').value}">
              <div class="user_div">
                  <mat-icon style="visibility: none;">user</mat-icon>
                  <span>
                      {{ "User not set" | translate }}
                  </span>
              </div>
          </mat-list-option>
          <ng-container *ngFor="let fil of employees$ | async">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('operation_employee_id').value == fil.id}">
                <app-user [class]="'user_div'" [employee]="fil" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'client_employee_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of employees$ | async">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('client_employee_id').value == fil.id}">
                <app-user [class]="'user_div'" [employee]="fil" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'channel_platform_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of platforms$ | async">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('channel_platform_id').value == fil.id}">
                  <div class="d-f-c">
                      <div class="platform_icon mr-1">
                          <app-platform [platform_id]="fil?.id"></app-platform>
                      </div>
                      <span class="fil_name">
                          {{fil.name}}
                      </span>
                  </div>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'task_status_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of taskStatuses$ | async">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('task_status_id').value == fil.id}">
                  <span class="fil_name">
                      {{fil.name}}
                  </span>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'priority'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of prioritys">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('priority').value == fil.id}">
                  <span class="fil_name">
                      {{fil.name}}
                  </span>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'content_status_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of profileStatuses">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('content_status_id').value == fil.id}">
                  <span class="fil_name">
                      {{fil.name | translate}}
                  </span>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'task_content_status_id'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <mat-list-option class="ch_fil_item" [value]="0" [ngClass]="{'active': filter.get('task_content_status_id').value == 0}">
              <span class="fil_name">
                  {{"Different" | translate}}
              </span>
          </mat-list-option>
          <ng-container *ngFor="let fil of profileStatuses">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('task_content_status_id').value == fil.id}">
                  <span class="fil_name">
                      {{fil.name | translate}}
                  </span>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'is_content_url'">
        <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
          <ng-container *ngFor="let fil of contentUrl">
              <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('is_content_url').value == fil.id}">
                  <span class="fil_name">
                      {{fil.name | translate}}
                  </span>
              </mat-list-option>
          </ng-container>  
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'task_operation_operation_id'">
        <ng-container *ngIf="section == 'Jobs'; else elseTemplateNoJobsMenu">
          <ng-container *ngIf="val?.id; else elseTemplateIsSingleChange">  
            <mat-selection-list class="ch_fil_items" [multiple]="false" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChangeSingleChange($event, 'task_operation_operation_id', val.id)">
              <ng-container *ngFor="let fil of jobTypes$ | async">
                  <mat-list-option class="cst_o flex_text" [value]="fil.id" [ngClass]="{'active': val.id == fil.id}">
                    <span class="fil_name">
                      {{fil.name | translate}}
                    </span>
                  </mat-list-option>
              </ng-container>
            </mat-selection-list>
          </ng-container>
          <ng-template #elseTemplateIsSingleChange>
            <mat-selection-list class="ch_fil_items" [multiple]="true" [appDeviceClass]="'custom-scroll custom-scroll-t'" (selectionChange)="selectChange($event, true, 'task_operation_operation_id')" [formControl]="filter.get('task_operation_operation_id')">
              <ng-container *ngFor="let fil of jobTypes$ | async">
                  <mat-list-option class="cst_o flex_text" [value]="fil.id" (click)="setFilValue($event, 'task_operation_operation_id', fil.id)" [ngClass]="{'active': filter.get('task_operation_operation_id').value.includes(fil.id)}">
                    <span class="fil_name">
                      {{fil.name | translate}}
                    </span>
                  </mat-list-option>
              </ng-container>
            </mat-selection-list>
            <div class="footer_line_fil">
              <button (click)="startSearch('task_operation_operation_id')">{{"Search" | translate}}</button>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #elseTemplateNoJobsMenu>          
          <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event, false, 'task_operation_operation_id')">
            <ng-container *ngFor="let fil of jobTypes$ | async">
                <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('task_operation_operation_id').value == fil.id}">
                    <span class="fil_name">
                        {{fil.name | translate}}
                    </span>
                </mat-list-option>
            </ng-container>  
          </mat-selection-list>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'no_operation_id'">
          <mat-selection-list class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event, false, 'no_operation_id')">
            <ng-container *ngFor="let fil of jobTypes$ | async">
                <mat-list-option class="ch_fil_item" [value]="fil.id" [ngClass]="{'active': filter.get('no_operation_id').value == fil.id}">
                    <span class="fil_name">
                        {{fil.name | translate}}
                    </span>
                </mat-list-option>
            </ng-container>  
          </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'content_type_id'">
          <mat-selection-list  class="ch_fil_items" [appDeviceClass]="'custom-scroll custom-scroll-t'" [multiple]="false" (selectionChange)="selectChange($event)">
            <mat-list-option class="ch_fil_item" [value]="0" [ngClass]="{'active': 0 === filter.get('content_type_id').value}">
                {{ "Content type not set" | translate}}
            </mat-list-option>
            <ng-container *ngFor="let contentType of contentTypes$ | async">
                <div mat-subheader>{{getPlatformById(contentType.channel_platform_id)?.name}}</div>
                <mat-list-option class="ch_fil_item" *ngFor="let fil of contentType.types" [value]="fil.id" [ngClass]="{'active': fil.id == filter.get('content_type_id').value}">
                    {{fil.name | translate}}
                </mat-list-option>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-selection-list>
      </ng-container>
      <ng-container *ngSwitchCase="'task_created_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_created_at_from')"
        [minDate]="minDate('task_created_at_from')"
        [maxDate]="maxDate('task_created_at_from')"
        [selected]="filter.get('task_created_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_created_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_created_at_to')"
        [minDate]="minDate('task_created_at_to')"
        [maxDate]="maxDate('task_created_at_to')"
        [selected]="filter.get('task_created_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_operation_created_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_operation_created_at_from')"
        [minDate]="minDate('task_operation_created_at_from')"
        [maxDate]="maxDate('task_operation_created_at_from')"
        [selected]="filter.get('task_operation_created_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_operation_created_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_operation_created_at_to')"
        [minDate]="minDate('task_operation_created_at_to')"
        [maxDate]="maxDate('task_operation_created_at_to')"
        [selected]="filter.get('task_operation_created_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_operation_completed_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_operation_completed_at_from')"
        [minDate]="minDate('task_operation_completed_at_from')"
        [maxDate]="maxDate('task_operation_completed_at_from')"
        [selected]="filter.get('task_operation_completed_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_operation_completed_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_operation_completed_at_to')"
        [minDate]="minDate('task_operation_completed_at_to')"
        [maxDate]="maxDate('task_operation_completed_at_to')"
        [selected]="filter.get('task_operation_completed_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'posted_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'posted_at_from')"
        [minDate]="minDate('posted_at_from')"
        [maxDate]="maxDate('posted_at_from')"
        [selected]="filter.get('posted_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'posted_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'posted_at_to')"
        [minDate]="minDate('posted_at_to')"
        [maxDate]="maxDate('posted_at_to')"
        [selected]="filter.get('posted_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_planned_completed_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'discussion_planned_completed_at_from')"
        [minDate]="minDate('discussion_planned_completed_at_from')"
        [maxDate]="maxDate('discussion_planned_completed_at_from')"
        [selected]="filter.get('discussion_planned_completed_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_planned_completed_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'discussion_planned_completed_at_to')"
        [minDate]="minDate('discussion_planned_completed_at_to')"
        [maxDate]="maxDate('discussion_planned_completed_at_to')"
        [selected]="filter.get('discussion_planned_completed_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_created_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'discussion_created_at_from')"
        [minDate]="minDate('discussion_created_at_from')"
        [maxDate]="maxDate('discussion_created_at_from')"
        [selected]="filter.get('discussion_created_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_created_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'discussion_created_at_to')"
        [minDate]="minDate('discussion_created_at_to')"
        [maxDate]="maxDate('discussion_created_at_to')"
        [selected]="filter.get('discussion_created_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_completed_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'discussion_completed_at_from')"
        [minDate]="minDate('discussion_completed_at_from')"
        [maxDate]="maxDate('discussion_completed_at_from')"
        [selected]="filter.get('discussion_completed_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'discussion_completed_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'discussion_completed_at_to')"
        [minDate]="minDate('discussion_completed_at_to')"
        [maxDate]="maxDate('discussion_completed_at_to')"
        [selected]="filter.get('discussion_completed_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'file_created_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'file_created_at_from')"
        [minDate]="minDate('file_created_at_from')"
        [maxDate]="maxDate('file_created_at_from')"
        [selected]="filter.get('file_created_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'file_created_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'file_created_at_to')"
        [minDate]="minDate('file_created_at_to')"
        [maxDate]="maxDate('file_created_at_to')"
        [selected]="filter.get('file_created_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'file_updated_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'file_updated_at_from')"
        [minDate]="minDate('file_updated_at_from')"
        [maxDate]="maxDate('file_updated_at_from')"
        [selected]="filter.get('file_updated_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'file_updated_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'file_updated_at_to')"
        [minDate]="minDate('file_updated_at_to')"
        [maxDate]="maxDate('file_updated_at_to')"
        [selected]="filter.get('file_updated_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'file_meta_creation_time_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'file_meta_creation_time_from')"
        [minDate]="minDate('file_meta_creation_time_from')"
        [maxDate]="maxDate('file_meta_creation_time_from')"
        [selected]="filter.get('file_meta_creation_time_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'file_meta_creation_time_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'file_meta_creation_time_to')"
        [minDate]="minDate('file_meta_creation_time_to')"
        [maxDate]="maxDate('file_meta_creation_time_to')"
        [selected]="filter.get('file_meta_creation_time_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_channel_published_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_channel_published_at_from')"
        [minDate]="minDate('task_channel_published_at_from')"
        [maxDate]="maxDate('task_channel_published_at_from')"
        [selected]="filter.get('task_channel_published_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'task_channel_published_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'task_channel_published_at_to')"
        [minDate]="minDate('task_channel_published_at_to')"
        [maxDate]="maxDate('task_channel_published_at_to')"
        [selected]="filter.get('task_channel_published_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'created_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'created_at_from')"
        [minDate]="minDate('created_at_from')"
        [maxDate]="maxDate('created_at_from')"
        [selected]="filter.get('created_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'created_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'created_at_to')"
        [minDate]="minDate('created_at_to')"
        [maxDate]="maxDate('created_at_to')"
        [selected]="filter.get('created_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'analytics_views_count_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'analytics_views_count_from')"
        [minDate]="minDate('analytics_views_count_from')"
        [maxDate]="maxDate('analytics_views_count_from')"
        [selected]="filter.get('analytics_views_count_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'analytics_views_count_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'analytics_views_count_to')"
        [minDate]="minDate('analytics_views_count_to')"
        [maxDate]="maxDate('analytics_views_count_to')"
        [selected]="filter.get('analytics_views_count_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'content_published_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'content_published_at_from')"
        [minDate]="minDate('content_published_at_from')"
        [maxDate]="maxDate('content_published_at_from')"
        [selected]="filter.get('content_published_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'content_published_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'content_published_at_to')"
        [minDate]="minDate('content_published_at_to')"
        [maxDate]="maxDate('content_published_at_to')"
        [selected]="filter.get('content_published_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'updated_at_from'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'updated_at_from')"
        [minDate]="minDate('updated_at_from')"
        [maxDate]="maxDate('updated_at_from')"
        [selected]="filter.get('updated_at_from').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchCase="'updated_at_to'">
        <mat-calendar 
        panelClass="example-month-picker"
        (selectedChange)="addEvent($event, 'updated_at_to')"
        [minDate]="minDate('updated_at_to')"
        [maxDate]="maxDate('updated_at_to')"
        [selected]="filter.get('updated_at_to').value"></mat-calendar>
      </ng-container>
      <ng-container *ngSwitchDefault>
        In developing...
      </ng-container>
    </ng-container>
    
    <!-- <pre [innerHTML]="val | json"></pre> -->
  </section>
</ng-template>